<template>
  <div class="result-item__card tour-card tour-card--horizontal">
    <div class="tour-card__detail">
      <div class="tour-card__img-wrapper">
        <div class="tour-card__img" :title="result.title">
          <picture>
            <source :data-srcset="getImagePrefixAddress + result.imageUrl" />

            <img
              src="/Themes/TripPlus/UI/Assets/images/public/default-image.svg"
              class="lazyload"
              :alt="result.title"
            />
            <!-- <img
            src="/Themes/TripPlus/UI/Assets/images/tourTest.png"
            class="lazyload"
            :alt="result.title"
          /> -->
          </picture>
        </div>
      </div>
      <div class="tour-card__info">
        <div class="tour-card__header">
          <div class="tour-card__title-item">
            <span class="tour-card__title" :title="result.title">
              {{ result.title }}
            </span>

            <button
              class="tour-card__bookmark btn btn--bookmark"
              ref="favoriteBtn"
              @click="toggleFavorite(result.travelPackageId)"
            >
              <i class="icon-bookmark" />
            </button>
          </div>
          <div class="tour-card__capacity hide-in-not-desktop">
            <span v-if="result.state === 1"> ظرفیت تور {{ result.tourCapacity }} </span>

            <span class="text-red" v-if="result.state === 4">
              ظرفیت این تور تکمیل شده است
            </span>

            <span class="text-red" v-if="result.state === 8">
              این تور لغو شده است
            </span>
          </div>
        </div>

        <ul class="tour-card__features">
          <!-- Tour Destinations -->
          <li class="tour-card__feature">
            <div class="tour-card__feature-title">
              تاریخ
            </div>
            <span v-if="result.plans && result.plans.length">
              {{ persianDate(firstRunDate) }} - {{ persianDate(endRunDate) }}
            </span>
            <span v-else>
              مشخص نیست
            </span>
          </li>

          <!-- Tour Hotel Rating -->
          <li class="tour-card__feature">
            <div class="tour-card__feature-title">
              اقامت
            </div>
            <span class="tour-card__day" v-if="result.numberOfNightsOfStay">
              {{ result.numberOfNightsOfStay }}
              شب
            </span>
            <span v-else>
              مشخص نیست
            </span>
          </li>

          <!-- Tour Date -->
          <li class="tour-card__feature">
            <div class="tour-card__feature-title">
              هواپیما
            </div>
            <span v-if="result.airLines && result.airLines.length">
              {{ result.airLines.map((al) => al.title).join("، ") }}
            </span>
            <span v-else>
              مشخص نیست
            </span>
          </li>

          <!-- Tour Airline & (Users Rate) -->
          <li class="tour-card__feature">
            <div class="tour-card__feature-title">
              نوع تور
            </div>
            <span>
              {{ result.tourType }}
            </span>
          </li>
        </ul>
      </div>
      <a :href="'/tour/' + result.slug" class="tour-card__link hide-in-desktop"> </a>
    </div>
    <div class="tour-card__price-box">
      <div class="tour-card__price" v-if="result.price && result.price.length">
        <span>شروع قیمت از</span>
        <ul class="tour-card__price-items">
          <li v-for="(price, index) in result.price" :key="index">
            <div class="tour-card__price-item">
              <span>{{ formatPrice(price.price) }}</span>
              <label class="tour-card__price-currency">{{ price.currency }}</label>
            </div>
          </li>
        </ul>
      </div>

      <div class="tour-card__price" v-else>
        <span>مشخص نیست‌</span>
      </div>

      <a
        v-if="!result.plans || result.plans.length === 1"
        :href="'/tour/' + result.slug"
        title="جزئیات و رزرو تور"
        class="tour-card__link-btn btn btn--primary btn--sm hide-in-not-desktop"
        >جزئیات و رزرو</a
      >
      <button
        v-else
        class="btn btn--primary mt--1"
        @click="() => (listVisibility = !listVisibility)"
        title="تاریخ‌های تور"
      >
        <span class="mx--1">
          تاریخ‌های تور
        </span>
        <i :class="listVisibility ? 'icon-up' : 'icon-down'"></i>
      </button>
    </div>
    <div v-if="listVisibility" class="result__item-child w-100">
      <table class="hide-in-not-desktop">
        <thead>
          <tr>
            <th>
              <span class="tour-card__feature-title">تاریخ رفت</span>
            </th>
            <th>
              <span class="tour-card__feature-title">تاریخ برگشت</span>
            </th>
            <th>
              <span class="tour-card__feature-title">قیمت</span>
            </th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="child in packagePlans" :key="child.travelPackagePlaneId">
            <td class="text-center">
              <span class="tour-card__feature-title">{{ persianDate(child.startDate, "dddd, jDD jMMMM jYYYY") }}</span>
            </td>

            <td class="text-center">
              <span class="tour-card__feature-title">{{ persianDate(child.endDate, "dddd, jDD jMMMM jYYYY") }}</span>
            </td>

            <td>
              <div class="result__item-child-price-wrapper">
                <div>
                  <div
                    v-for="(executionDatePrice, executionDateIndex) in child.minPrice.priceList"
                    :key="'executionDateIndex' + executionDateIndex"
                    class="result__item-price text-center"
                  >
                    <span>{{ formatPrice(executionDatePrice.price) }}</span>
                    <label>{{ executionDatePrice.currency }}</label>
                  </div>
                </div>
              </div>
            </td>
            <td>
              <div class="result__item-child-link-wrapper">
                <a
                  :href="'/tour/' + result.slug + `/?selectedTourId=${child.travelPackagePlaneId}`"
                  class="btn btn--primary result__btn-reserve"
                  title="خرید آنلاین"
                >
                  <span class="mx--1">
                    خرید آنلاین
                  </span>
                  <i class="icon-arrow-left"></i>
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- execution cards wrapper -->
      <div class="result__item-child-mobile hide-in-desktop px--2">
        <!-- execution card -->
        <div
          class="result__item-child-mobile__item py--2"
          v-for="child in result.plans"
          :key="child.travelPackagePlaneId + 'travelPackagePlan-mobile'"
        >
          <div class="result__item-child-date-mobile my--2">
            <div class="result__item-child-date-mobile__col">
              <span>
                {{ persianDate(child.startDate, `dddd`) }}
              </span>
              <span>
                {{ persianDate(child.startDate, `jDD jMMMM jYYYY`) }}
              </span>
            </div>

            <div class="result__item-divider w-100 px--2">
              <div class="w-100" />
              <i class="icon-plane-line" />
            </div>

            <div class="result__item-child-date-mobile__col">
              <span>
                {{ persianDate(child.endDate, `dddd`) }}
              </span>
              <span>
                {{ persianDate(child.endDate, `jDD jMMMM jYYYY`) }}
              </span>
            </div>
          </div>
          <!-- footer card wrapper -->
          <div class="result__item-child-footer-mobile">
            <div>
              <div
                v-for="(executionDatePrice, executionDateIndex) in child.minPrice.priceList"
                :key="'executionDateIndex' + executionDateIndex"
                class="result__item-price"
              >
                <span>{{ formatPrice(executionDatePrice.price) }}</span>
                <label>{{ executionDatePrice.currency }}</label>
              </div>
            </div>

            <a
              :href="'/tour/' + result.slug + `/?selectedTourId=${child.travelPackagePlaneId}`"
              class="btn btn--primary result__btn-reserve"
              title="خرید آنلاین"
            >
              <span class="mx--1">
                خرید آنلاین
              </span>
              <i class="icon-arrow-left"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import moment from "moment-jalaali";

export default {
  name: "ResultItem",

  props: {
    result: {
      type: Object,
    },
  },

  data() {
    return {
      firstRunDate: "",
      endRunDate: "",
      listVisibility: false,
    };
  },

  computed: {
    ...mapGetters(["getImagePrefixAddress", "getAddFavoriteUrl", "getFavoritePrefix", "getIsUserAuthenticated"]),
    packagePlans(){
      // sort plans by their startDate
      return [...this.result.plans].sort((a,b)=> new Date(a.startDate).getTime() - new Date(b.startDate).getTime())
    }
  },

  methods: {
    ...mapActions(["addToFavorite", "showAlert"]),

    // toggle tour favorite
    toggleFavorite(tourId) {
      if (this.getIsUserAuthenticated) {
        this.addToFavorite({
          element: this.$refs.favoriteBtn,
          entityType: 1001,
          entityRef: tourId,
          url: this.getFavoritePrefix,
        });
      } else {
        this.showAlert({
          messages: [
            {
              message: "برای دسترسی به این قسمت باید وارد سایت شوید",
              type: 2,
            },
          ],
        });
      }
    },

    // return persian date
    persianDate(date, format = "jDD jMMMM ") {
      moment.loadPersian({
        dialect: "persian-modern",
      });
      return date ? moment(date).format(format) : "";
    },

    getDiscountPercent(discountedPrice, originalPrice) {
      var priceDifference = originalPrice - discountedPrice;
      var discountPercentage = (priceDifference / originalPrice) * 100;
      return Math.round(discountPercentage);
    },

    // format price
    formatPrice(price) {
      if (price) {
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return "";
      }
    },
  },

  created() {
    this.firstRunDate = this.result.plans[0].startDate;
    this.endRunDate = this.result.plans[this.result.plans.length - 1].endDate;
  },
};
</script>
<style lang="scss">
@import "../style/modules/_result.scss";
</style>
